export default __webpack_public_path__ + "static/logo-34018132b340feae5a18bfa6d741e1c3.png";